import { REG_EXP } from './util.models';
import { CountrySelectedValue } from './doctorregistration';
import { SelectItem } from 'primeng/api/selectitem';
import { ApiResult } from './PromiseResult';
import { PaginationModel } from './util.models';
import { ROLES } from 'src/app/constant/constant';

export class SupporCreateUser {
  vendor_guid: string = null;
  first_name: string = '';
  middle_name: string = '';
  last_name: string = '';
  primary_contact_number: string = '';
  secondary_contact_number: string = '';
  country_id: number = 0;
  state_id: number = 0;
  address: string = null;
  consultation_type_id: number = 0;
  permamnent_country_id: number = 0;
  permamnent_state_id: number = 0;
  permanent_address: string = '';
  // policy_no: string = '';
  // expiry_date: string = '';
  // expiry_Date_date: Date = null;
  booking_id_no: string = '';
  date_of_birth: string = '';
  date_of_birth_date: Date = null;
  gender: string = null;
  e_email: string = null;
  has_consented = false;
}
export class other_data {
  regExp: REG_EXP = new REG_EXP();
  primary_contact_no: string = null;
  secondary_contact_no: string = null;
  selected_country_data: CountrySelectedValue = new CountrySelectedValue();
  selected_vendor_data: VendorSelectedValue = new VendorSelectedValue();
  selected_consultation_type: ConsultationSelectedValue =
    new ConsultationSelectedValue();
  selected_primary_country: get_selected_item = new get_selected_item();
  selected_secondary_country: get_selected_item1 = new get_selected_item1();
  selected_state: get_States = new get_States();
  selected_permanent_state: get_States = new get_States();
  selected_permanent_country: get_selected_item = new get_selected_item();
  countries: SelectItem[] = [];
  countries_codes: SelectItem[] = [];
  countries_codes_secondart: SelectItem[] = [];
  status: SelectItem[] = [];
  states: SelectItem[] = [];
  p_states: SelectItem[] = [];
  vendor_list: SelectItem[] = [];
  consultation_type_list: SelectItem[] = [];
  vendor_name: string;
  vendor_guid: string;
  consultation_type: string;
  consultation_type_id: number;
  currentDate: Date = new Date();
  is_help_and_care: boolean = false;
}
export class CreateUser {
  supporCreateUser: SupporCreateUser = new SupporCreateUser();
  other_data: other_data = new other_data();
  create_api_result: ApiResult = new ApiResult(false);
  consultations_api_result: ApiResult = new ApiResult(false);
  viewDetails: ViewDetails = new ViewDetails();
  other_user_list: user_list_other_data = new user_list_other_data();
  other_view_details: view_details_other_data = new view_details_other_data();
  contactUser: ContactUser = new ContactUser();
  loading: boolean = false;
  display: boolean = false;
  success: boolean = false;
  posting: boolean = false;
  resetData() {
    this.supporCreateUser = new SupporCreateUser();
    this.other_data.primary_contact_no = '';
    this.other_data.secondary_contact_no = '';
    this.other_data.selected_consultation_type =
      new ConsultationSelectedValue();
    this.other_data.selected_vendor_data = new VendorSelectedValue();
    this.other_data.selected_primary_country = new get_selected_item();
    this.other_data.selected_secondary_country = new get_selected_item();
    this.other_data.selected_state = new get_States();
    this.other_data.selected_permanent_state = new get_States();
    this.other_data.selected_permanent_country = new get_selected_item();

  }
}

export class user_list_other_data {
  status: SelectItem[] = [];
  disabledDates: boolean = true;
  ErrorMessage: string = null;
  total_records: number = 0;
  maxDate: Date = new Date();
  invalid_date_message: boolean = false;
  query: VendorFetchFilter;
  VendorDataList: VendorDataList[] = [];
  roles = ROLES;
  medical_profession_role: number;
  is_support_role: boolean = false;
  download_data: DownloadCsvData;
}

export class get_selected_item {
  id: number = 0;
  is_national_license: boolean = null;
  phone_code: string = '';
  name:
    string = '';
}
export class get_selected_item1 {
  id: number = 0;
  is_national_license: boolean = null;
  phone_code: string = '';
  name:
    string = '';
}
export class get_States {
  id: string = '';
  name: string = '';
}

export class p_get_States {
  id: string = '';
  name: string = '';
}

export class view_details_other_data {
  req_id: number = null;
  isactivity: boolean = false;
  isPatientContactActivity: boolean = false;
  activities_list: GetRequestActivity[] = [];
  patient_contacted_list: ContactPatientRequest[] = [];
  medical_profession_role: number;
  is_support_role: boolean = false;
  roles = ROLES;
}

export enum filters {
  None = 'none',
  booking_id_no = 'booking_id_no',
  policy_no = 'policy_no',
  primary_contact_number = 'primary_contact_number',
  first_name = 'first_name',
  last_name = 'last_name'
}
export const filters_name = {
  [filters.None]: 'Select',
  [filters.booking_id_no]: 'Booking Id',
  [filters.policy_no]: 'Policy No.',
  [filters.primary_contact_number]: 'Phone No.',
  [filters.first_name]: 'First Name',
  [filters.last_name]: 'Last Name'
};

export class VendorFetchFilter extends PaginationModel {
  status: string;
  from_date: string;
  to_date: string;
  first: 0;
  filter_key: filters;
  filter_value: string;
  vendor_guid: string;
}

export class VendorSelectedValue {
  vendor_guid: string;
  country_id: number;
  vendor_name: string;
}
export class ConsultationSelectedValue {
  consultation_type_id: number;
  country_id: number;
  label: string;
}
export class DownloadCsvData {
  status: string;
  from_date: string;
  to_date: string;
  filter_key: string;
  filter_value: string;
}

export class VendorDataList {
  sr_no: number;
  req_id: number;
  vendor_guid: string;
  name: string;
  country_id: number;
  state_id: number;
  first_name: string;
  middle_name: string;
  last_name: string;
  primary_contact_number: number;
  address: string;
  policy_no: string;
  expiry_date: Date;
  booking_id_no: string;
  vendor_name: string;
  date_of_birth: Date;
  doctor_assigned: string;
  gender: string;
  e_email: string;
  status: string;
  error_msg: string;
  created_at: string;
  updated_at: Date;
  patient_user_guid: string;
  patient_guid: string;
  package_id: number;
  consultation_id: number;
  updated_by_user_guid: string;
  slots_assigned: string;
  has_consented: boolean;
  consultation_request_number: string;
  condition_description: string;
  consultation_created_at: string;
  consultation_date: string;
  consultation_closed_date: string;
  consultation_type_id: number;
  consultation_type_name: string;
  user_package_id: string;
}
export class consent_update {
  req_id: number;
  has_consented: boolean;
}
export class ViewDetails {
  req_id: number;
  vendor_guid: string;
  name: string;
  first_name: string;
  middle_name: string;
  last_name: string;
  primary_contact_number: number;
  country_id: number;
  state_id: number;
  address: string;
  policy_no: string;
  expiry_date: Date;
  booking_id_no: number;
  date_of_birth: Date;
  gender: string;
  e_email: string;
  status: string;
  error_msg: string;
  patient_user_guid: string;
  patient_guid: string;
  package_id: string;
  consultation_id: string;
  doctor_user_guid: string;
  updated_by_user_guid: string;
  created_at: Date;
  updated_at: Date;
  egd_vendors: {
    vendor_name: string;
  };
  country: {
    country_name: string;
  };
  country_states: {
    state_name: string;
  };
  e_users: {
    primary_contact_number: number;
    e_email: string;
    first_name: string;
    middle_name: string;
    last_name: string;
    date_of_birth: Date;
    user_source_id: number;
    other_user_source: string;
    user_source: {
      source: string;
    };
  };
  p_accounts: {
    relation: string;
    first_name: string;
    middle_name: string;
    last_name: string;
    gender: string;
    date_of_birth: Date;
    address_line_1: string;
    city: string;
    state_name: string;
    zip_code: string;
    primary_contact_number: number;
    country: {
      country_name: string;
    };
  };
  user_package: {
    nickname: string;
    expires_at: Date;
  };
  update_egd_users: {
    d_email: string;
    first_name: string;
    middle_name: string;
    last_name: string;
    primary_contact_number: number;
  };
  p_consultation: {
    consultation_status: string;
    condition_description: string;
    consultation_date: Date;
    consultation_request_number: string;
  };
  consultation_name: string;
}
export class ContactUser {
  req_id: number = null;
  reason: string = '';
  comments: string = '';
}
export interface GetRequestActivity {
  timestamp: Date;
  action: string;
}
export interface ContactPatientRequest {
  id: number;
  reason: string;
  comments: string;
  first_name: string;
  last_name: string;
}
